export default __webpack_public_path__ + "static/media/Level22.f5544cdf.svg";